<template>
<!--   <b-container> -->
 
    <v-layout
      flex-child
      wrap
      style="height:100vh"
    >
      <v-flex xs12 md10>
          <a href="https://www.smartpress.co/"><img
          v-if="!$vuetify.breakpoint.smAndDown"
        src="../../assets/logo.png"
        height="45px"
        @click="window.location.replace('https://www.smart.press')"
        style="position:absolute;left:30px;top:20px;margin-left:0px;cursor:pointer; "
      ></a>
        <div style="width:300px;transform: translateX(40%) translateY(160px);" v-if="!$vuetify.breakpoint.smAndDown">

            <h2><v-icon medium style="color:silver; margin-right:10px">account_circle</v-icon>Sign up</h2>
            <p>For A <span style="font-weight:600">Smartpress</span> Account</p>
             
               
                <v-text-field
                  
                  id="emailInput"
                  type="email"
                  v-model="email"
                  required
                  placeholder="Email"
                   />
                <v-text-field
                  v-if="email != ''"
                  id="nameInput"
                  type="text"
                  v-model="name"
                  required
                  placeholder="Full name"
                   />
                 <v-text-field
                style="width:100%"
                  v-if="name != ''"
                  id="usernameInput"
                  type="text"
                  v-model="username"
                  required
                  placeholder="Enter a username"
                   />
                <v-text-field
                  v-if="username != ''"
                  id="passwordInput"
                  type="password"
                  v-model="pass"
                  required
                  placeholder="Enter a Password"
                   />
                   <span v-if="username != ''" style="font-size:10px">Include a special character, a number and an uppercase letter</span>
                <v-text-field
                  v-if="username != ''"
                  id="passwordInput"
                  type="password"
                  v-model="pass1"
                  required
                  placeholder="Confirm Password"
                   />
                <span v-if="pass != '' && pass1 != '' && pass1 != pass">Do not match</span>
                <br/>
              </b-form-group>
              <v-btn
                type="submit" 
                variant="primary"
                color="primary"
                v-if="pass1 == pass && pass != ''"
                @click="signUp">Submit</v-btn>

              or <b-link @click="signinPage()">Sign in</b-link>

              <b-link style="float:right; margin-top:10px; color:silver" to="../terms">Terms</b-link>
         
            <v-alert/>
            <br/>
          </div>

 <div style="width:80%;margin:40px;" v-if="$vuetify.breakpoint.smAndDown">
   <img
        src="../../assets/logo.png"
        height="32px"
        style="margin-bottom:16px;"
        
      >

            <h2><v-icon medium style="color:silver; margin-right:10px">account_circle</v-icon>Sign up</h2>
            <p>For A <span style="font-weight:600">Smart Contract</span> Account</p>

            <!--  <b-link to="../terms">Terms</b-link> -->
                <v-text-field
                  
                  id="emailInput"
                  type="email"
                  v-model="email"
                  required
                  placeholder="Enter email"
                   />
                <v-text-field
                  v-if="email != ''"
                  id="usernameInput"
                  type="text"
                  v-model="username"
                  required
                  placeholder="Enter username"
                   />
                <v-text-field
                  v-if="username != ''"
                  id="nameInput"
                  type="text"
                  v-model="name"
                  required
                  placeholder="Full name"
                   />
                <v-text-field
                  v-if="username != ''"
                  id="passwordInput"
                  type="password"
                  v-model="pass"
                  required
                  placeholder="Enter Password"
                   />
                  <span v-if="username != ''" style="font-size:10px">Include a special character, a number and an uppercase letter</span>
                <v-text-field
                  v-if="username != ''"
                  id="passwordInput"
                  type="password"
                  v-model="pass1"
                  required
                  placeholder="Confirm Password"
                   />

                   <br/>
                <span v-if="pass != '' && pass1 != '' && pass1 != pass">Do not match</span>
              
              </b-form-group>
              <v-btn
                v-if="pass1 == pass && pass != ''"
                type="submit" 
                variant="primary"
                color="primary"
                @click="signUp">Submit</v-btn>

              or <b-link @click="signinPage()">Sign in</b-link>


         
            <v-alert/>
             <b-link style="float:right; margin-top:10px; color:gray" to="../terms">Terms</b-link>
         
            <v-alert/>
            <br/>
            
          </div>
 
      </v-flex>
      
      <v-flex style="background-color:#5764E4" v-if="!$vuetify.breakpoint.smAndDown"   xs2> 
          <img
          
          src="../../assets/Art/Smartpress-connect.svg"
          height="305px"
           
          style="position:absolute;right:100px;top:50vh;margin-left:0px;cursor:pointer; "
        >
      </v-flex>
  </v-layout>
<!--   </b-container> -->
</template>

<script>
import Vue from "vue"
import router from "@/router"
import { mapGetters } from "vuex"
import Alert from "@/components/auth/Alert.vue"
import Amplify from "@aws-amplify/core"

const Logger = Amplify.Logger

Vue.component("v-alert", Alert)

const logger = new Logger("SignUpPage")

export default {
  data() {
    return {
      username: "",
      email: "",
      name: "",
      pass: "",
      pass1: ""
    }
  },
  mounted() {
    // clear existing status message
    this.$store.dispatch("auth/clearAuthenticationStatus")

  },
  computed: {
    ...mapGetters("auth", ["hasAuthenticationStatus"])
  },
  methods: {
    
    async signUp() {
      logger.debug("sign-up")
      await this.$store.dispatch("auth/signUp", {
        username: this.username.toLowerCase(),
        password: this.pass,
        attributes: {
          name: this.name,
          email: this.email
        }
      })

      if (!this.hasAuthenticationStatus) {
        this.$cookies.set('newSignup', 'true')
        this.$cookies.set('spUserEmail', this.email)
        router.push({name: 'confirmSignUp', params: { incomingUserType: this.$route.params.incomingUserType }})
      }
    },
    signinPage: function () {
      router.push({name: 'signIn', params: { incomingUserType: this.$route.params.incomingUserType }})
    }
  }
}
</script>

<style>
::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
}


</style>
